import { ImportBomCsvResult } from "@redotech/redo-inventory-common/bom-csv-upload";
import * as z from "zod";

export const uploadBillOfMaterialsCsv = {
  name: "uploadBillOfMaterialsCsv" as const,
  input: z.object({}),
  output: ImportBomCsvResult,
};
